export default "__VITE_ASSET__d669c01d__"